module.exports = __webpack_public_path__ + "img/2018-12-16-6.8db4371e.jpeg";